<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <title-text />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <mail-to />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/Defines/Webform_departments/Elements/TitleText.vue'
import MailTo from '@/views/Admin/Defines/Webform_departments/Elements/MailTo.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    TitleText,
    MailTo,
  },
  computed: {
    itemData() {
      return this.$store.getters['webformDepartments/dataItem']
    },
  },
}
</script>
